import React from 'react';
import PlatformIcon from './PlatformIcon';

const ICON = { viewBox: '0 0 24 24', width: 16, height: 16, 'aria-hidden': 'true', fill: 'currentColor' };

function ClickIcon() {
  return (
    <svg {...ICON}>
      <path d="M5.6 2.4a1 1 0 0 1 1.08.2l12 11.4a1 1 0 0 1-.6 1.72l-5.03.47 2.6 4.5a1 1 0 0 1-.37 1.37l-2.2 1.26a1 1 0 0 1-1.37-.37l-2.6-4.5-3.3 3.83A1 1 0 0 1 5 21.6V3.3a1 1 0 0 1 .6-.9Z" />
    </svg>
  );
}

function SettingsIcon() {
  return (
    <svg {...ICON} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M4 6h5m4 0h7M4 12h9m4 0h3M4 18h3m4 0h9" />
      <circle cx="11" cy="6" r="2" />
      <circle cx="15" cy="12" r="2" />
      <circle cx="9" cy="18" r="2" />
    </svg>
  );
}

function TeamIcon() {
  return (
    <svg {...ICON}>
      <path d="M9 11.4a3.7 3.7 0 1 0 0-7.4 3.7 3.7 0 0 0 0 7.4Zm0 1.6c-3.1 0-6 1.7-6 3.9V20h12v-3.1c0-2.2-2.9-3.9-6-3.9Zm7.6-1.6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm.4 1.7c-.7 0-1.4.1-2 .3 1.3 1 2 2.3 2 3.6V20h5v-2.7c0-1.9-2.4-3.2-5-3.2Z" />
    </svg>
  );
}

function AuditIcon() {
  return (
    <svg {...ICON}>
      <path d="M7 2.5h7.2L19 7.3V20a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 6 20V4a1.5 1.5 0 0 1 1-1.5Zm6.7 1.9V8h3.6l-3.6-3.6ZM9 11.5h6a.9.9 0 1 1 0 1.8H9a.9.9 0 1 1 0-1.8Zm0 3.6h6a.9.9 0 1 1 0 1.8H9a.9.9 0 1 1 0-1.8Zm0-7.2h2.4a.9.9 0 1 1 0 1.8H9a.9.9 0 0 1 0-1.8Z" />
    </svg>
  );
}

function DocsIcon() {
  return (
    <svg {...ICON}>
      <path d="M4 4.6c0-1 .8-1.7 1.8-1.6l4.5.5c.7.1 1.2.6 1.2 1.3v14.4c0 .7-.6 1.2-1.3 1.1l-4.6-.6A1.7 1.7 0 0 1 4 18V4.6Zm16 0V18c0 .8-.6 1.6-1.4 1.7l-4.6.6c-.7.1-1.3-.4-1.3-1.1V4.8c0-.7.5-1.2 1.2-1.3l4.5-.5c1-.1 1.8.6 1.8 1.6Z" />
    </svg>
  );
}

const ITEMS = [
  { key: 'android', label: 'Android', icon: () => <PlatformIcon platform="android" />, permission: 'apps.read' },
  { key: 'ios', label: 'iOS', icon: () => <PlatformIcon platform="ios" />, permission: 'apps.read' },
  { key: 'statistics', label: 'Click Log', icon: ClickIcon, permission: 'clicks.read' },
  { key: 'settings', label: 'Settings', icon: SettingsIcon, permission: 'blocklists.read' },
  { key: 'team', label: 'Team', icon: TeamIcon, permission: 'users.manage' },
  { key: 'audit', label: 'Audit', icon: AuditIcon, permission: 'audit.read' },
  { key: 'docs', label: 'Docs', icon: DocsIcon },
];

export function visibleTabs(permissions, superAdmin) {
  return ITEMS.filter(
    (item) => !item.permission || superAdmin || (permissions || []).includes(item.permission)
  );
}

export default function Tabs({ activeTab, setActiveTab, permissions, superAdmin }) {
  const items = visibleTabs(permissions, superAdmin);

  return (
    <div className="main-tabs" role="tablist">
      {items.map((item) => {
        const Icon = item.icon;

        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={activeTab === item.key}
            className={`main-tab${activeTab === item.key ? ' is-active' : ''}`}
            onClick={() => setActiveTab(item.key)}
          >
            {Icon ? <Icon /> : null}
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
